import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import type { AiChatSuggestion } from '@shipstation/aiui';

import Global from '../../../store/global-selectors';
import { useWallet } from '../../../wallet/hooks/use-wallet';
import { messages } from '../messages';

type OnboardingRule = {
  id: string;
  isComplete: boolean;
  message: typeof messages.onboardingStoreQuestion;
};

const STOCK_QUESTIONS = [
  { id: 'example-1', messageKey: 'exampleQuestion1' as const },
  { id: 'example-2', messageKey: 'exampleQuestion2' as const },
  { id: 'example-3', messageKey: 'exampleQuestion3' as const },
];

const TARGET_COUNT = 3;

export const useExampleQuestions = (): AiChatSuggestion[] => {
  const intl = useIntl();
  const activeStores = useSelector(Global.selectSellerActiveStores);
  const shipFroms = useSelector(Global.selectSellerShipFroms);
  const wallet = useWallet();

  return useMemo(() => {
    const hasActiveNonManualStore = activeStores.some((store: { isManualStore: boolean }) => !store.isManualStore);

    const onboardingRules: OnboardingRule[] = [
      { id: 'onboarding-store', isComplete: hasActiveNonManualStore, message: messages.onboardingStoreQuestion },
      { id: 'onboarding-ship-from', isComplete: shipFroms.length > 0, message: messages.onboardingShipFromQuestion },
      { id: 'onboarding-wallet', isComplete: !!wallet.isWalletRegistered, message: messages.onboardingWalletQuestion },
    ];

    const incompleteRules = onboardingRules.filter((rule) => !rule.isComplete);

    const onboarding = incompleteRules.slice(0, TARGET_COUNT).map((rule) => ({ id: rule.id, label: intl.formatMessage(rule.message) }));

    const stock = STOCK_QUESTIONS.slice(0, TARGET_COUNT - onboarding.length).map((q) => ({
      id: q.id,
      label: intl.formatMessage(messages[q.messageKey]),
    }));

    return [...onboarding, ...stock];
  }, [intl, activeStores, shipFroms, wallet.isWalletRegistered]);
};
